'use strict';

var clickOutsideController = function ($scope, $element, $attrs, $document) {
    $document.on('click', function (e) {
        if ($element !== e.target && !$element[0].contains(e.target)) {
            $scope.$apply($scope.onCalendarClose());
        }
    });
};

var clickOutsideLink = function ($scope, $element, $attrs, ctrl) { };

clickOutsideController.$inject = ['$scope', '$element', '$attrs', '$document'];

module.exports = function () {
    return {
        restrict: 'A',
        scope: {
            onCalendarClose: '&'
        },
        controller: clickOutsideController,
        link: clickOutsideLink
    }
}
